import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { LOADING_CONTEXT } from '@ps/core-overlay';

import { GetSurveysFilters, Survey } from '../models/invoice-survey.model';
import { SurveyMapper } from './mappers/invoice-survey.mapper';
import { SurveyPayloadMapper } from './mappers/invoice-survey.payload.mapper';
import { SurveyDto } from './dtos/invoice-survey.dto';

@Injectable({ providedIn: 'root' })
export class InvoiceSurveysApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}/buyers/v2/surveys`;
  private readonly _mapper = new SurveyMapper();
  private readonly _payloadMapper = new SurveyPayloadMapper();

  public get(filters: GetSurveysFilters, page: number): Observable<Survey[]> {
    const params = this._payloadMapper.toPayload({ ...filters, page });

    return this._http
      .get<SurveyDto[]>(this._baseUrl, {
        params,
        context: new HttpContext().set(LOADING_CONTEXT, true),
      })
      .pipe(map((surveys) => this._mapper.fromDtoList(surveys)));
  }
}
